import { z } from 'zod'

const SecurityImpactSchema = z.object({ impact: z.string().trim().nullish() }).nullish()

export function securityImpact(analysis: unknown): string | null {
  const parsed = SecurityImpactSchema.safeParse(analysis)
  return parsed.success && parsed.data?.impact
    ? parsed.data.impact
    : null
}
